import maDamagesTypes from '@/modules/Damage/views/damagesTypes'
import maDamagedItems from '@/modules/Damage/views/damagedItems'
import maDamagedParts from '@/modules/Damage/views/damagedParts'
import maDamagesDetails from '@/modules/Damage/views/damagesDetails'
import maDamagesView from '@/modules/Damage/views/damagesView'
import maDamagesConfirmed from '@/modules/Damage/views/damagesConfirmed'
import maDamagesExtraDetails from '@/modules/Damage/views/damagesExtraDetails'
import maDamageResultUptec from '@/modules/Damage/views/damageResultUptec'
import maDamageValidation from '@/modules/Damage/views/damageValidation'
import maDamageMobiler from '@/modules/Damage/views/damageMobilier'
import maDamageMobilerUptecFeature from '@/modules/Damage/views/damageMobilierUptecFeature'
import maDamageMobilerCategory1 from '@/modules/Damage/views/damageMobilierCategory1'
import maDamageMobilerCategory2 from '@/modules/Damage/views/damageMobilierCategory2'
import maDamageMobilerCategory3 from '@/modules/Damage/views/damageMobilierCategory3'
import maMultidamagedList from '@/modules/Damage/views/multidamageList'
import maDamageMobilierValidation from '@/modules/Damage/views/damageMobilierValidation'
import maDamageFraisValidation from '@/modules/Damage/views/damageFraisValidation'

export const damageRouter = [
  {
    path: '/damages-types/:propertyType',
    name: 'damages-types',
    component: maDamagesTypes
  },
  {
    path: '/damaged-items/:propertyType/:damageType',
    name: 'damaged-items',
    component: maDamagedItems
  },
  {
    path: '/damaged-parts/:propertyType/:damageType/:damagedItem',
    name: 'damaged-parts',
    component: maDamagedParts
  },
  {
    path: '/damage-details/:propertyType/:damageType/:damagedItem',
    name: 'damage-details',
    component: maDamagesDetails
  },
  {
    path: '/multidamage-list/:propertyType/:damageType/:damagedItem',
    name: 'multidamage-list',
    component: maMultidamagedList
  },
  {
    path: '/damages-view',
    name: 'damages-view',
    component: maDamagesView
  },
  {
    path: '/damages-confirmed/',
    name: 'damage-confirmed',
    component: maDamagesConfirmed
  },
  {
    path: '/damage-extra-details/:damageId',
    name: 'damage-extra-details',
    component: maDamagesExtraDetails
  },
  {
    path: '/damage-result-uptec/:propertyType/:damageType/',
    name: 'damage-result-uptec',
    component: maDamageResultUptec
  },
  {
    path: '/damage-validation/',
    name: 'damage-validation',
    component: maDamageValidation
  },
  {
    path: '/damage-validated/',
    name: 'damage-validated',
    component: maDamageMobiler
  },
  {
    path: '/damage-mobilier/:propertyType/:damageType/',
    name: 'damageMobilier',
    component: maDamageMobiler
  },
  {
    path: '/damage-mobilier-uptec/:propertyType/:damageType/:productId',
    name: 'damageMobilierUptecFeature',
    component: maDamageMobilerUptecFeature
  },
  {
    path: '/damage-mobilier-category1/:propertyType/:damageType/',
    name: 'damageMobilierCategory1',
    component: maDamageMobilerCategory1
  },
  {
    path: '/damage-mobilier-category2/:propertyType/:damageType/',
    name: 'damageMobilierCategory2',
    component: maDamageMobilerCategory2
  },
  {
    path: '/damage-mobilier-category3/:propertyType/:damageType/',
    name: 'damageMobilierCategory3',
    component: maDamageMobilerCategory3
  },
  {
    path: '/damage-validated-mobilier/:user/:sinisterId/:propertyType/:damageType/:warrantyId/',
    name: 'damage-validated-mobilier',
    component: maDamageMobilierValidation
  },
  {
    path: '/damage-validated-frais/:user/:sinisterId/:propertyType/:damageType/:warrantyId/',
    name: 'damage-validated-frais',
    component: maDamageFraisValidation
  }
]
